import React from 'react';
import { Box, Container, Heading, Text, Stack, VStack } from '@chakra-ui/react';
import Navigation from '../Navigation/Navigation';
import { useNavigate, useOutletContext } from 'react-router-dom';
import '../../styles/fonts.css';

const About = () => {
  const navigate = useNavigate();
  const { isAuthenticated, onLogOut } = useOutletContext();

  return (
    <Box bg="#F5F3F0" minH="100vh">
      <Navigation
        bg="#F5F3F0"
        onRouteChange={(route) => navigate(`/${route}`)}
        onLogOut={onLogOut}
        isAuthenticated={isAuthenticated}
      />
      <Container maxW="800px" px={8} py={16}>
        <VStack spacing={10} align="stretch">
          <Heading
            fontWeight="700"
            color="#1A1A1A"
            fontSize="3xl"
            textAlign="center"
            letterSpacing="-0.02em"
          >
            About Writewizard
          </Heading>

          <Box
            bg="white"
            borderRadius="xl"
            border="1px solid"
            borderColor="#E4E4E7"
            boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
            p={10}
          >
            <Stack spacing={6}>
              <Text fontSize="lg" color="#1A1A1A" lineHeight="1.85" className="snippet-text">
                Welcome to Writewizard, your AI-powered creative writing companion. This platform
                combines the power of artificial intelligence with human creativity to help you craft
                compelling stories, develop rich characters, and build immersive worlds.
              </Text>

              <Text fontSize="lg" color="#1A1A1A" lineHeight="1.85" className="snippet-text">
                Whether you're a seasoned author or just starting your writing journey, Writewizard
                provides the tools and support you need to bring your stories to life. Our intelligent
                assistant helps you overcome writer's block, suggests plot developments, and ensures
                your narrative flows seamlessly.
              </Text>

              <Text fontSize="lg" color="#1A1A1A" lineHeight="1.85" className="snippet-text">
                With Writewizard, you can:
                {'\n'}• Create and organize your stories chapter by chapter
                {'\n'}• Get AI-powered suggestions and improvements
                {'\n'}• Share your work with a community of fellow writers
              </Text>

              <Text fontSize="lg" color="#1A1A1A" lineHeight="1.85" className="snippet-text">
                Join this growing community of writers and discover how AI can enhance your creative
                process. Writewizard is more than just a writing tool – it's your partner in
                storytelling.
              </Text>
            </Stack>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default About;
